import React, { useEffect } from 'react'
import { Col, RadioButton, Radio, Spin } from 'core/components/ui'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { InputWrapper, InterTitle } from '../../styled'

const FormItem = ({
  vehicle,
  onChange,
  loading,
  paramsTyresTypeQuestion,
  getParamsTyresTypeQuestion
}) => {
  useEffect(() => {
    getParamsTyresTypeQuestion()
  }, [])

  const handleChange = e => {
    const { value } = e.target
    const extendedVehicle = {
      ...vehicle,
      tyresType: value
    }
    onChange(extendedVehicle)
  }

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 12 }}>
      <InterTitle>
        <FormattedMessage id="tradeIn-state-tires-3" />
      </InterTitle>

      <InputWrapper type="flex">
        <Col span={24}>
          {loading ? (
            <Spin />
          ) : (
            <Radio.Group
              buttonStyle="solid"
              value={vehicle && vehicle.tyresType}
              onChange={handleChange}
            >
              {paramsTyresTypeQuestion.map(item => (
                <RadioButton value={item.key} key={item.key}>
                  {item.value}
                </RadioButton>
              ))}
            </Radio.Group>
          )}
        </Col>
      </InputWrapper>
    </Col>
  )
}

FormItem.defaultProps = {
  loading: true,
  paramsTyresTypeQuestion: []
}

FormItem.propTypes = {
  vehicle: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.any,
  paramsTyresTypeQuestion: PropTypes.array,
  getParamsTyresTypeQuestion: PropTypes.func.isRequired
}

export default { FormItem }
